import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";
import { ApiResponse } from "models";

const initialState: any = {
  loading: false,
  success: false,
  message: "",
  addRoleLoading: false,
  addRoleMessage: "",
  updateRoleLoading: false,
  updateRoleMessage: "",
  deleteRoleloading: false,
  deleteRoleMessage: "",
  data: {},
  moduledata: {},
  listByIdLoading: false,
  listByIdSuccess: false,
  listByIdData: {},
  roleByIdLoading: false,
  roleByIdSuccess: false,
  roleByIdData: {},
};

const accessRoleSlice = createSlice({
  name: "accessRole",
  initialState,
  reducers: {
    getAccessRoleList(state, action: PayloadAction<ApiResponse>) {
      state.loading = true;
      state.message = "";
    },
    getAccessRoleListSuccess(state, action: PayloadAction<any>) {
      state.loading = false;
      state.data = action.payload;
      state.success = action.payload.success;
    },
    getAccessRoleListFailed(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      state.data = {};
      state.message = action.payload?.message;
      state.success = action.payload?.success;
    },
    getAccessRoleById(state, action: PayloadAction<ApiResponse>) {
      state.roleByIdLoading = true;
      state.roleByIdSuccess = false;
    },
    getAccessRoleByIdSuccess(state, action: PayloadAction<any>) {
      state.roleByIdLoading = false;
      state.roleByIdData = action.payload.data;
      state.roleByIdSuccess = action.payload.success;
    },
    getAccessRoleByIdFailed(state, action: PayloadAction<ApiResponse>) {
      state.roleByIdLoading = false;
      state.roleByIdData = {};
      state.roleByIdSuccess = action.payload?.success;
    },
    getModuleList(state, action: PayloadAction<ApiResponse>) {
      state.loading = true;
      state.message = "";
    },
    getModuleListSuccess(state, action: PayloadAction<any>) {
      state.loading = false;
      state.moduledata = action.payload;
      state.success = action.payload.success;
    },
    getModuleListFailed(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      state.moduledata = {};
      state.message = action.payload?.message;
      state.success = action.payload?.success;
    },
    getModuleById(state, action: PayloadAction<ApiResponse>) {
      state.listByIdLoading = true;
      state.listByIdData = {};
      state.listByIdSuccess = false;
    },
    getModuleByIdSuccess(state, action: PayloadAction<ApiResponse>) {
      state.listByIdLoading = false;
      state.listByIdData = action.payload.data;
      state.listByIdSuccess = action.payload.success;
    },
    getModuleByIdFailed(state, action: PayloadAction<ApiResponse>) {
      state.listByIdLoading = false;
      state.listByIdData = action.payload.data;
      state.listByIdSuccess = action.payload.success;
    },
    addAccessRole(state, action: PayloadAction<ApiResponse>) {
      state.addRoleLoading = true;
      state.addRoleMessage = "";
    },
    addAccessRoleSuccess(state, action: PayloadAction<ApiResponse>) {
      state.addRoleLoading = false;
      state.addRoleMessage = action.payload.message;
      state.success = action.payload.success;
    },
    addAccessRoleFailed(state, action: PayloadAction<ApiResponse>) {
      state.addRoleLoading = false;
      state.message = action.payload.message;
      state.success = action.payload.success;
    },
    updateAccessRole(state, action: PayloadAction<ApiResponse>) {
      state.updateRoleLoading = true;
      state.updateRoleMessage = "";
    },
    updateAccessRoleSuccess(state, action: PayloadAction<ApiResponse>) {
      state.updateRoleLoading = false;
      state.updateRoleMessage = action.payload.message;
      state.success = action.payload.success;
    },
    updateAccessRoleFailed(state, action: PayloadAction<ApiResponse>) {
      state.updateRoleLoading = false;
      state.updateRoleMessage = action.payload.message;
      state.success = action.payload.success;
    },
    deleteAccessRole(state, action: PayloadAction<ApiResponse>) {
      state.deleteRoleloading = true;
      state.deleteMessage = "";
    },
    deleteAccessRoleSuccess(state, action: PayloadAction<ApiResponse>) {
      state.deleteRoleloading = false;
      state.deleteRoleMessage = action.payload.message;
      state.success = action.payload.success;
    },
    deleteAccessRoleFailed(state, action: PayloadAction<ApiResponse>) {
      state.deleteRoleloading = false;
      state.deleteRoleMessage = action.payload.message;
      state.success = action.payload.success;
    },
    clearData(state) {
      state.loading = false;
      state.success = false;
      state.message = "";
      state.addRoleLoading = false;
      state.addRoleMessage = "";
      state.updateRoleLoading = false;
      state.updateRoleMessage = "";
      state.deleteRoleloading = false;
      state.deleteRoleMessage = "";
    },
  },
});

//Actions
export const accessRoleActions = accessRoleSlice.actions;

//Selectors
export const getAccessRoleList = (state: RootState) => state.accessRole.data;
export const getAccessRoleById = (state: RootState) =>
  state.accessRole.roleByIdData;
export const getModuleList = (state: RootState) => state.accessRole.moduledata;
export const getModuleById = (state: RootState) =>
  state.accessRole.listByIdData;
export const selecetMessage = (state: RootState) => state.accessRole.message;
export const selectSuccess = (state: RootState) => state.accessRole.success;
export const selectLoading = (state: RootState) => state.accessRole.loading;
export const selectAddRoleLoading = (state: RootState) =>
  state.accessRole.addRoleLoading;
export const selectAddRoleMessage = (state: RootState) =>
  state.accessRole.addRoleMessage;
export const selectUpdateRoleLoading = (state: RootState) =>
  state.accessRole.updateRoleLoading;
export const selectUpdateRoleMessage = (state: RootState) =>
  state.accessRole.updateRoleMessage;
export const selectDeleteRoleLoading = (state: RootState) =>
  state.accessRole.deleteRoleloading;
export const selectDeleteRoleMessage = (state: RootState) =>
  state.accessRole.deleteRoleMessage;

//Reducers
const accessRoleReducer = accessRoleSlice.reducer;
export default accessRoleReducer;
